module.exports = __webpack_public_path__ + "img/img-baseball.dd7d3b31.png";